export const SCOPE_SUPER_ADMIN = 'super-admin';
export const SCOPE_MULTI_ACCOUNT_COPY_ASSETS_WRITE = 'multi-account-copy-assets-write';